const Views = self => ({
    isBiggerThan(size) {
        return self.minSize && self.maxSize && self.minSize >= size / 2 && self.maxSize >= size;
    },
});
export default Views;
